module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/calendar.json
// module id = 469
// module chunks = 206379351349907